import Ajax from "./ajax";
import { jsToFormData } from "@/utils/func";

// 毕业论文
// -成教
export const adultStudentPpsGetReport = data => Ajax.get(`/fs-pps-get-report`, data);  //获取一阶段设计资料
export const adultStudentPpsUpReport = data => Ajax.post(`/fs-pps-up-report`, jsToFormData(data));  //上传一阶段设计资料
export const adultStudentPpsUpDevise = data => Ajax.post(`/fs-pps-up-devise`, jsToFormData(data));  //上传设计资料
export const adultStudentPpsGetQa = data => Ajax.get(`/fs-pps-get-qa`, data);  //获取问答
export const adultStudentPpsUpAa = data => Ajax.post(`/fs-pps-up-qa`, jsToFormData(data));  //上传问答
export const adultStudentPpsUpDuplicate = data => Ajax.post(`/fs-pps-up-duplicate`, jsToFormData(data));  //上传查重附件
export const adultStudentPpsUpDuplicateRedo = data => Ajax.post(`/fs-pps-up-duplicate-redo`, jsToFormData(data));  //上传查重附件-重新提交
export const ppsReDuplicate = data => Ajax.post(`/fs-pps-re-duplicate`, jsToFormData(data));  //重提设计资料

export const adultStudentPpAll = data => Ajax.get(`/fs-pp-all`, data);  //论文计划筛选数据
export const adultStudentPpsDuplicate = data => Ajax.get(`/fs-pps-duplicate`, data);  //获取查重记录
export const studentPpsDuplicateUrl = data => Ajax.get(`/fs-pps-duplicate-url`, data);  //获取查重记录
export const ppsRevokeDuplicate = data => Ajax.post(`/fs-pps-revoke-duplicate`, jsToFormData(data));  //撤销答辩申请
export const studentSubmitSign = data => Ajax.post(`/fs-submit-sign`, jsToFormData(data));  //毕业设计报名提交
export const studentSubmitDeclaration = data => Ajax.post(`/fs-submit-declaration`, jsToFormData(data));  //毕业设计原创性声明提交
export const studentPpsInfo = data => Ajax.get(`/fs-pps-info`, data);  //获取毕业设计计划学生详情
export const studentSubmitStatement = data => Ajax.post(`/fs-submit-statement`, jsToFormData(data));  //毕业设计任务书提交
export const studentSubmitReport = data => Ajax.post(`/fs-submit-report`, jsToFormData(data));  //毕业设计开题报告提交

export const studentGetStatement = data => Ajax.get(`/fs-get-statement`, data);  //获取任务书信息
export const studentGetReport = data => Ajax.get(`/fs-get-report`, data);  //获取开题报告信息


// 毕业答辩
export const studentPpsGetReply = data => Ajax.get(`/fs-pps-get-reply`, data);  //获取查重记录

// 成绩申请
export const studentGetScoreApply = data => Ajax.get(`/fs-get-score-apply`, data);  //获取成绩申请记录
export const ppsScoreApply = data => Ajax.post(`/fs-pps-score-apply`, jsToFormData(data));  //提交成绩申请
export const revokeScoreApply = data => Ajax.post(`/fs-revoke-score-apply`, jsToFormData(data));  //提交成绩申请

// 成教-专科 成绩申请
export const getZkScore = data => Ajax.get(`/v1-adult-student-get-zk-score`, data);  //获取专科成绩申请记录
export const zkScoreApply = data => Ajax.post(`/v1-adult-student-zk-score-apply`, jsToFormData(data));  //专科成绩申请



